var linesConfig = require('cfg/lines-config').lines;
var frameConfig = require('cfg/frames-config').frame;
var Animation = require('animation').Animation;
var SlotLine = require('slotline').SlotLine;
var LineBillet = require('linebillet').LineBillet;
var SlotFrame = require('slotframe').SlotFrame;
import Space from "frp/space"
import { Image } from 'utils'

/** The same as slot-win-presenter.js but with all anonymous functions rewritten as overridable fields.*/
export default class SlotWinPresenter extends PIXI.Container
{
    /**
    * Constructs SlotWinPresenter.
    * @class
    * @constructor
    * @param {SlotMath} slotMath Slot mathematics as data source to represent proper wins
    * @param {Object} config Configuration
    * @param {Object} delegate Delegate which responds on win show event
    * @name SlotWinPresenter
    * @classdesc This is a supplementary unit which holds {@link SlotLine|lines}, {@link SlotBillet|billets}, {@link SlotFrame|frames}, {@link SymbolAnimation symbol animations} and does win show
    * by its own
    * @extends {PIXI.Container}
    * */
    constructor( slotMath, config, delegate, space )
    {
        super()

        this.delegate = delegate;
        
        this.space = space || new Space

        this.hideBarrelElement = null;

        this.showBarrelElement = null;

        this._slotMath = slotMath;

        this._config = config;

        this._symbolAnimation = [];

        this.lines_container = new PIXI.Container
        this.addChild( this.lines_container )

        const $symbol_animation_start = space.s( "symbol_animation_start" )
        const $symbol_animation_end = space.s( "symbol_animation_end" )
        $symbol_animation_start
            .filter( () => this.winLines )
            //only when animation STARTS:
            .map( frame => ({ frame, line : this.currentLineId() }) )
            .filter( ({ frame, line}) =>
                //skip WILD symbols on a lane which does NOT consist of wilds only:
                frame.j == slotMath.lineWinSymbol( line )
                &&
                //skip symbols of other lines:
                slotMath.lineWinPositions( line ).indexOf( frame.i ) >= 0
                &&
                //ignore secondary symbols on the same lane:
                line != this.last_line_symbol_animation
            )
            .do( ({ line }) => {
                this.last_line_symbol_animation = line
                delete this.next_line_symbol_animation
            } )
            // .do( () => console.log( ( new Date ).toISOString(), "start" ) )
            .to( space.s( "line_symbol_animation_start" ) )
        //report next line animation start:
        $symbol_animation_start
            .filter( () =>
                this.delegate
                &&
                this.delegate.sndWinSymbols
                &&
                this.delegate.sndWinSymbols[ slotMath.lineWinSymbol( this.currentLineId() ) ]
                &&
                ! this.delegate.sndWinSymbols[ slotMath.lineWinSymbol( this.currentLineId() ) ].playing()
            )
            .filter( () => this.firstTime )
            //only when animation STARTS:
            .map( frame => ({
                    frame,
                    line : this.currentLineId(),
                    next_line_id : this.winLines[ this.lineIdx + 1 < this.winLines.length ? this.lineIdx + 1 : 0 ]
                })
            )
            .filter( ({ frame, line, next_line_id }) =>
                next_line_id != line
                &&
                //skip WILD symbols on a lane which does NOT consist of wilds only:
                frame.j == slotMath.lineWinSymbol( next_line_id )
                &&
                //skip symbols of other lines:
                slotMath.lineWinPositions( next_line_id ).indexOf( frame.i ) >= 0
                &&
                next_line_id != this.next_line_symbol_animation
            )
            .do( ({ line, next_line_id }) => this.next_line_symbol_animation = next_line_id)
            .to( space.s( "next_line_symbol_animation_start" ) )

        if ( config.animation_frames_count || config.symbol_animation_sequence ) {
            for ( let j = 0; j < slotMath.symbolsNumber(); ++j) {

                let xOffset = 0;
                let yOffset = 0;
                
                if (config.animation_offsets) {
                    xOffset = config.animation_offsets[j].x;
                    yOffset = config.animation_offsets[j].y;
                }
                
                let animationSpeed = 0.2;
                
                if (config.animation_speed) {
                    animationSpeed = config.animation_speed[j];
                }
                if ( config.animation_frame_delay ) {
                    //array with per-animation values:
                    if ( isNaN( config.animation_frame_delay ) )
                    {
                        animationSpeed = Animation.animationSpeedByFrameDelay( config.animation_frame_delay[ j ] );
                    }
                    //... or just a value to use for all animations:
                    else
                    {
                        animationSpeed = Animation.animationSpeedByFrameDelay( config.animation_frame_delay );
                    }
                }
                
                const postfix = config.symbol_animation_filename_pattern_postfix || "_%03d.png";
                const symbol_name = config.symbol_animation_filename_pattern.$( j, j );
                const frameName = symbol_name + postfix;
                
                const symbols_positions_count = config.barrel.rows * config.barrel.reels;

                for ( let i = 0; i < symbols_positions_count; ++i) {
                    
                    const $flow = space.s( symbol_name + "_pos_" + i )
                    $flow
                        .filter( frame => frame.first )
                        .map( () => ({ i, j }) )
                        .to( $symbol_animation_start )
                    $flow
                        .filter( frame => frame.last )
                        .map( () => ({ i, j }) )
                        .to( $symbol_animation_end )
                    
                    let animation
                    if ( config.symbol_animation_sequence ) animation = Animation.fromFrames(
                        config.symbol_animation_sequence.map( ssi => frameName.$( ssi ) ),
                        $flow
                    )
                    else animation = Animation.byFrameName(
                        frameName,
                        config.animation_frames_count[j],
                        $flow
                    );
                    animation.animationSpeed = animationSpeed;
                    animation.anchor.x = 0;
                    animation.anchor.y = 0;
            
                    const pos = SlotWinPresenter.symbol_index_to_pos( config, i )
            
                    animation.x = this.elX( config, pos.col ) + xOffset;
                    animation.y = this.elY( config, pos.row ) + yOffset;
                    animation.visible = false;
                    this.addChild(animation);
                    this._symbolAnimation.push(animation);
                }
            }
        }

        
        this.barrelUpperContainer = new PIXI.Container();
        this.barrelUpperContainer.position.set(0, 0);
        this.addChild(this.barrelUpperContainer);
        
        if ( config.lines_filename_pattern )
        {
            this._lines = [];
            for (var i = 0; i < this._slotMath.linesNumber(); ++i) {
                var line = new SlotLine(config.lines_filename_pattern.$(i), linesConfig[i],
                                        config.frames_filename_pattern.$(i), frameConfig, config.barrel);

                this._lines.push(line);
                this.lines_container.addChild(line);

                this.hideLine(i);
            }
            if ( ! config.lines_under ) this.addChild( this.lines_container )
        }

        this._scatterFrames = [];
        if (config.scatter_frames_filename_pattern !== undefined) {
            for (var i = 0; i < config.barrel.reels; ++i) {
                if (frameConfig !== undefined && frameConfig !== null) {
                    for (i = 0; i < 5; ++i) {
                        var frame = new SlotFrame(config.scatter_frames_filename_pattern.$(i), frameConfig);

                        var col = i;

                        frame.x = this.elX( config, col ) + ( config.barrel.frameOffset ? config.barrel.frameOffset.x : 0 );
                        //frame.y = this.elY( barrelConfig, row ) + ( this.config.barrel.frameOffset ? this.config.barrel.frameOffset.y : 0 );
                        frame.visible = false; // изначально не видима


                        this.addChild(frame);
                        this._scatterFrames.push(frame);
                    }
                }
            }
        }

        if ( config.left_billets_whole )
        {
            const lbw = Image( config.left_billets_whole.name )
            lbw.position.set( config.left_billets_whole.pos[ 0 ], config.left_billets_whole.pos[ 1 ] )
            this.addChild( lbw )
        }
        if ( config.right_billets_whole )
        {
            const rbw = Image( config.right_billets_whole.name )
            rbw.position.set( config.right_billets_whole.pos[ 0 ], config.right_billets_whole.pos[ 1 ] )
            this.addChild( rbw )
        }
        if (config.left_billets_on_filename_pattern && config.right_billets_on_filename_pattern)
        {
            this._leftBillets = [];
            for (var i = 0; i < this._slotMath.linesNumber(); ++i) {
                var billet = new LineBillet(
                    config.left_billets_on_filename_pattern.$(i),
                    config.left_billets_off_filename_pattern && config.left_billets_off_filename_pattern.$(i)
                )
                const coords = config.left_billets_coords || config.left_billets_on_coords
                billet.position.x = coords[ i ].x
                billet.position.y = coords[ i ].y
                this.addChild(billet);
                this._leftBillets.push(billet);
            }

            this._rightBillets = [];
            for (var i = 0; i < this._slotMath.linesNumber(); ++i) {
                var billet = new LineBillet(
                    config.right_billets_on_filename_pattern.$(i),
                    config.right_billets_off_filename_pattern && config.right_billets_off_filename_pattern.$(i)
                )
                const coords = config.right_billets_coords || config.right_billets_on_coords
                billet.position.x = coords[ i ].x
                billet.position.y = coords[ i ].y
                this.addChild(billet);
                this._rightBillets.push(billet);
            }
        }
        else if (config.billets_on_filename_pattern)
        {
            this._billets = [];
            for (var i = 0; i < this._slotMath.linesNumber(); ++i) {
                var billet = new LineBillet(config.billets_on_filename_pattern.$(i), config.billets_off_filename_pattern && config.billets_off_filename_pattern.$(i));
                billet.position.x = config.billets_coords[i].x;
                billet.position.y = config.billets_coords[i].y;
                this.addChild(billet);
                this._billets.push(billet);
            }
        }
    }

    /** Left global ( where 0 is leftmost window pixel) coordinate of reel symbol at specified column.
    * @param {Object} c Slot config with barrel field.*/
    elX( c, column )
    {
        return SlotWinPresenter.el_x( c, column )
    }
    static el_x( c, column )
    {
        if ( c.barrel.positions_x ) return c.barrel.positions_x[ column ]
        return c.barrel.position.x + column * ( c.barrel.cellSize.width + ( c.barrel.reelGap || 0 ) );
    }
    /** Top global (where 0 is uppermost window pixel) coordinate of reel symbol at specified row.
    * @param {Object} c Slot config with barrel field.*/
    elY( c, row )
    {
        return SlotWinPresenter.el_y( c, row )
    }
    static el_y( c, row )
    {
        if ( c.barrel.positions_y ) return c.barrel.positions_y[ column ]
        return c.barrel.position.y + row * ( c.barrel.cellSize.height + ( c.barrel.cellGap || 0 ) );
    }

    /**
    * Handles starting symbol animation.
    * @param {Number} idx reel position
    * */
    onSymbolAnimationStart( idx ) {
        var els = this._slotMath.slotSymbols();
        var symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        return this._symbolAnimation[ els[ idx ] * symbols_positions_count + idx ];
    }

    /**
    * Handles stopping symbol animation.
    * @param {Number} idx reel position
    * */
    onSymbolAnimationStop( idx ) {
        var els = this._slotMath.slotSymbols();
        var symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        return this._symbolAnimation[els[idx] * symbols_positions_count + idx];
    }


    /**
    * Shows line with frames on specified positions.
    * @param {Number} line Line index
    * @param {Number[]} positions Array of reel positions. Positions which are out of line trajectory will be omitted.
    * @memberOf SlotWinPresenter
    * */
    showCroppedLine( line, positions ) {
        if ( this._lines ) {
            this._lines[line].cutPositions(positions);
            this._lines[line].fadeIn();
        }
    }

    /**
    * Hides line with frames on specified positions.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    hideCroppedLine( line ) {
        if ( this._lines ) this._lines[line].fadeOut();
    }

    /**
    * Shows entire line.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    showLine( line ) {
        if ( this._lines ) this._lines[line].fadeIn();
    }
    
    /**
    * Checks if specified line is visible or not.
    * @param {Number} line Line index
    * @returns {Boolean} true - lines is visible, false - line is hidden
    * @memberOf SlotWinPresenter
    * */
    lineIsVisible( line ) {
        if ( this._lines ) return this._lines[line].visible;
    }
    
    /**
    * Checks if active billets are visible or not.
    * @param {Number} line Line index
    * @returns {Boolean} true - billets are visible, false - billets are hidden
    * @memberOf SlotWinPresenter
    * */
    activeBilletsAreVisible( line ) {
        if (this._billets) {
            return this._billets[line].activeBilletIsVisible();
        }
        else if (this._leftBillets && this._rightBillets) {
            return this._leftBillets[line].activeBilletIsVisible();
        }
        
        return false;
    }

    showScatterFrames() {
        if (this._scatterFrames.length > 0) {
            var scatterPosition = this._slotMath.scatterPositions();
            for (var i = 0; i < scatterPosition.length; ++i) {
                var col = scatterPosition[i] / this._config.barrel.rows | 0;
                var row = scatterPosition[i] % this._config.barrel.rows | 0;
                this._scatterFrames[col].y = this.elY( this._config ) + ( this._config.barrel.frameOffset ? this._config.barrel.frameOffset.y : 0 );
                this._scatterFrames[col].visible = true;
            }
        }
        else {
            return;
        }
    }

    hideScatterFrames() {
        if (this._scatterFrames.length > 0) {
            for (var i = 0; i < this._scatterFrames.length; ++i) {
                this._scatterFrames[i].visible = false;
            }
        }
        else {
            return;
        }
    }

    /**
    * Hides line.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    hideLine( line ) {
        if ( this._lines ) this._lines[line].hide();
    }

    /**
    * Restores line cropped positions.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    restoreLine( line ) {
        if ( this._lines ) this._lines[line].restoreLine();
    }

    /**
    * Shows inactive billets.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    showInactiveBillets( line ) {
        if (this._billets) {
            this._billets[line].showOffBillet();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].showOffBillet();
            this._rightBillets[line].showOffBillet();
        }
    }

    /**
    * Hides inactive billets.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    hideInactiveBillets( line ) {
        if (this._billets) {
            this._billets[line].hideOffBillet();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].hideOffBillet();
            this._rightBillets[line].hideOffBillet();
        }
    }

    /**
    * Shows active billets.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    showActiveBillets( line ) {
        if (this._billets) {
            this._billets[line].showOnBillet();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].showOnBillet();
            this._rightBillets[line].showOnBillet();
        }
    }

    /**
    * Hides active billets.
    * @param {Number} line Line index
    * @memberOf SlotWinPresenter
    * */
    hideActiveBillets( line ) {
        if (this._billets) {
            this._billets[line].hideOnBillet();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].hideOnBillet();
            this._rightBillets[line].hideOnBillet();
        }
    }

    /** @param {Number} line Line index */
    fadeInActiveBillets( line ) {
        if (this._billets) {
            this._billets[line].fadeIn();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].fadeIn();
            this._rightBillets[line].fadeIn();
        }
    }

    /** @param {Number} line Line index */
    fadeOutActiveBillets( line ) {
        if (this._billets) {
            this._billets[line].fadeOut();
        }
        else if (this._leftBillets && this._rightBillets) {
            this._leftBillets[line].fadeOut();
            this._rightBillets[line].fadeOut();
        }
    }
    
    startSymbolsAnimation() {
        
        this.last_line_symbol_animation = -1
        
        this._slotMath.winSymbolsPositions().forEach( idx => {
            if (this.hideBarrelElement) {
                this.hideBarrelElement(idx);
            }

            const animation = this.onSymbolAnimationStart(idx);
            if (animation) {
                animation.visible = true;
                animation.gotoAndPlay(0);
            }
        } )
    }

    stopSymbolsAnimation() {
        var winSymbolsPositions = this._slotMath.winSymbolsPositions();

        var self = this;

        winSymbolsPositions.forEach(function(idx) {
            if (self.showBarrelElement) {
                self.showBarrelElement(idx);
            }

            var animation = self.onSymbolAnimationStop(idx);

            if (animation) {
                animation.visible = false;
                animation.stop();
            }
        });
    }

    /** Enques animation function execution which can be interrupted and canceled with this.interruptShowWin() */
    then( func, delayMs )
    {
        this.timeID = setTimeout( func.bind( this ), delayMs );
    }

    currentLineId() {
        return this.winLines[ this.lineIdx ];
    }
    nextLineId() {
        this.lineIdx++;
        if ( this.lineIdx >= this.winLines.length) {
            this.lineIdx = 0;
            this.firstTime = false;
        }
        return this.winLines[ this.lineIdx ];
    }

    /**
    * Interrupts show win process.
    * @param {Object} slotPresenter
    * @memberOf SlotWinPresenter
    * */
    interruptShowWin( slotPresenter, math, silently ) {
        //not sure about the logic of interrupting already interrupted animation, so just lets leave it untouched:
        if ( this.timeID )
        {
            clearTimeout(this.timeID);
            this.timeID = null;
        }

        this.hideScatterFrames();

        for (var i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            this.hideLine(i);
            this.restoreLine(i);
        }

        for (var i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            slotPresenter.showActiveBillets(i);
        }

        slotPresenter.stopSymbolsAnimation();

        if ( ! silently ) {
            if (this.delegate) this.delegate.winShowDidFinish();
        }
    }

    /**
    * Starts win show process.
    * @param {Object} slotPresenter this
    * @param {Object} math Mathematics as data source to show wins properly
    * @memberOf SlotWinPresenter
    * */
    showWin( slotPresenter, math ) {
        this.slotPresenter = slotPresenter;
        this.math = math;
        
        this.winLines = math.winLines();
        this.lineIdx = 0;
        this.firstTime = false;

        if (this.delegate) this.delegate.winShowDidStart();
        
        this.showWinBegin_regular();
    }
    showWinBegin_regular() {
        this.slotPresenter.startSymbolsAnimation();

        // прячем плашки
        for (var i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            this.slotPresenter.showInactiveBillets(i);
            this.slotPresenter.hideActiveBillets(i);
        }

        //если есть выигрышные линии и возможно скаттеры
        if ( this.winLines.length > 0 ) {
            this.then( this.showAllWinLines_regular, 300 ); // дадим время погаснуть плашкам
        }
        // если только скаттеры выиграли
        else if( this.math.scatterWin() > 0 ) {
            this.then( this.showScattersWin_regular, 300 );
        }
    }
    showAllWinLines_regular() {
        for (var i = 0; i < this.winLines.length; ++i) {
            this.slotPresenter.showActiveBillets( this.winLines[ i ] );
            this.slotPresenter.showLine( this.winLines[ i ] );
        }
        
        this.then( this.hideAllWinLines_regular, 1000 );
    }
    hideAllWinLines_regular() {
        for (var i = 0; i < this.winLines.length; ++i) {
            this.slotPresenter.hideActiveBillets( this.winLines[ i ] );
            this.slotPresenter.hideLine( this.winLines[ i ] );
        }

        this.then( this.showLinesOneByOne_regular, 1000 );
    }
    showLinesOneByOne_regular() {
        this.firstTime = true;
        this.slotPresenter.showActiveBillets( this.currentLineId() );
        this.slotPresenter.showCroppedLine( this.currentLineId(), this.math.lineWinPositions( this.currentLineId() ) );
        
        let duration = 1000;
        let specifiedDuration;
        if ( this.delegate )
        {
            specifiedDuration = this.delegate.lineDidShow(
                this.currentLineId(),
                this.math.lineWin( this.currentLineId() ),
                this.firstTime,
                this.lineIdx
            );
            if ( ! isNaN( specifiedDuration ) ) {
                duration = specifiedDuration * 1000;
            }
        }
        
        if ( specifiedDuration != "reactive" ) {
            if ( this.winLines.length === 1 && this.math.scatterWin() === 0) {
                this.then( this.showSingleLine_regular, duration );
            }
            else {
                this.then( this.showNextLine_regular, duration );
            }
        }
    }
    progress_line_show__regular() {
        if ( this.winLines.length === 1 && this.math.scatterWin() === 0) {
            this.showSingleLine_regular()
        }
        else {
            this.showNextLine_regular()
        }
    }
    showSingleLine_regular( specifiedDuration ) {
        if ( specifiedDuration != "reactive" || !this.firstTime ) this.then( this.showSingleLine_regular, 1000 );
    }
    showNextLine_regular() {
        var currentLine = this.currentLineId();

        // если показали последнюю линию и есть скаттеры
        if ( this.lineIdx == this.winLines.length - 1 && this.math.scatterWin() > 0 ) {
            this.slotPresenter.hideActiveBillets( currentLine );
            this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );
            
            if ( this.delegate ) this.delegate.lineDidHide( currentLine, this.firstTime );
            
            this.then( function() {
                this.showScattersWin_regular();
                this.nextLineId();
            }, 1000);
        }
        else {
            var nextLine = this.nextLineId();

            if (currentLine != nextLine) {
                this.slotPresenter.hideActiveBillets( currentLine );
                this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );

                if ( this.delegate ) this.delegate.lineDidHide( currentLine );

                this.slotPresenter.showActiveBillets( nextLine );
                this.slotPresenter.showCroppedLine( nextLine, this.math.lineWinPositions( nextLine ) );

                var duration = 1000;
                if ( this.delegate )
                {
                    var specifiedDuration = this.delegate.lineDidShow(
                        nextLine,
                        this.math.lineWin( nextLine ),
                        this.firstTime,
                        this.lineIdx
                    );
                    if ( ! isNaN( specifiedDuration ) )
                    {
                        duration = specifiedDuration * 1000;
                    }
                }

                if ( specifiedDuration != "reactive" || !this.firstTime ) this.then( this.showNextLine_regular, duration );
            }
        }
    }
    showScattersWin_regular() {
        this.showScatterFrames();
        
        var duration = 1000;
        if ( this.delegate )
        {
            var specifiedDuration = this.delegate.scattersDidShow( this.math.scatterWin(), this.firstTime );
            if ( ! isNaN( specifiedDuration ) )
            {
                duration = specifiedDuration * 1000;
            }
        }
        
        if ( this.winLines.length > 0 ) {
            this.then( function () {
                if ( this.delegate ) this.delegate.scattersDidHide();

                this.hideScatterFrames();

                this.showLinesOneByOne_regular();
            }, duration );
        }
    }

    /**
    * Starts win show process before extra games.
    * @param {Object} slotPresenter this
    * @param {Object} math Mathematics as data source to show wins properly
    * @param {Function} done Callback to be called on show ending
    * @memberOf SlotWinPresenter
    * */
    showWinBeforeExtraGames( slotPresenter, math, done ){
        this.slotPresenter = slotPresenter;
        this.math = math;
        this.done = done;
        
        this.winLines = math.winLines();
        this.lineIdx = 0;
        this.firstTime = true;
        
        // начало показа выигрыша (все что было до этого это приватные функции частей показа выигрыша)
        if (this.delegate) this.delegate.winShowDidStart();
        
        slotPresenter.startSymbolsAnimation();
        
        if ( this.delegate ) this.delegate.scattersDidShow( this.math.scatterWin(), true );

        // прячем плашки
        for (var i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            slotPresenter.showInactiveBillets(i);
            slotPresenter.hideActiveBillets(i);
        }
        
        this.showWinBegin_beforeExtra();
    }
    showWinBegin_beforeExtra() {
        //если есть выигрышные линии и возможно скаттеры
        if ( this.winLines.length > 0 ) {
            this.then( this.showAllWinLines_beforeExtra, 300 ); // дадим время погаснуть плашкам перед показом всех выигрышных линий
        }
        // если только скаттеры выиграли
        else if(this.math.scatterWin() > 0) {
            this.then( this.showScattersWin_beforeExtra, 500 );
        }
        // если выпал бонус при осуствии выигрыша за спин, тогда просто ждем конца анимации
        else if (this.math.hasBonus()) {
            this.then( this.finishShowWin_beforeExtra, 2000 )
        }
    }
    showAllWinLines_beforeExtra() {
        for (var i = 0; i < this.winLines.length; ++i) {
            this.slotPresenter.showActiveBillets( this.winLines[ i ] );
            this.slotPresenter.showLine( this.winLines[ i ] );
        }

        this.then( this.hideAllWinLines_beforeExtra, 1000 );
    }
    hideAllWinLines_beforeExtra() {
        for (var i = 0; i < this.winLines.length; ++i) {
            this.slotPresenter.hideActiveBillets( this.winLines[ i ] );
            this.slotPresenter.hideLine( this.winLines[ i ] );
        }

        this.then( this.showLinesOneByOne_beforeExtra, 1000 );
    }
    showLinesOneByOne_beforeExtra() {
        this.slotPresenter.showActiveBillets( this.currentLineId() );
        this.slotPresenter.showCroppedLine( this.currentLineId(), this.math.lineWinPositions( this.currentLineId() ) );
        
        if ( this.delegate ) {
            this.delegate.lineDidShow( this.currentLineId(), this.math.lineWin( this.currentLineId() ), true );
        }

        if ( this.winLines.length === 1 && this.math.scatterWin() === 0 ) {
            this.then( this.finishShowWin_beforeExtra, 1000 );
        }
        else {
            this.then( this.showNextLine_beforeExtra, 1000 );
        }
    }
    showNextLine_beforeExtra() {
        var currentLine = this.currentLineId();
        
        // если показали последнюю линию и есть скаттеры
        if ( this.lineIdx == this.winLines.length - 1 && ( this.math.scatterCount() > 0 || this.math.hasBonus() ) ) {
            this.slotPresenter.hideActiveBillets( currentLine );
            this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );
        
            if ( this.delegate ) {
                this.delegate.lineDidHide( currentLine, true );
            }

            if ( this.math.scatterWin() > 0 ) {
                this.showScattersWin_beforeExtra();
            }
            else {
                this.then( finishShowWin_beforeExtra, 1000 );
            }
        }
        else {
            var nextLine = this.nextLineId();
        
            if (currentLine != nextLine) {
                this.slotPresenter.hideActiveBillets( currentLine );
                this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );
                
                if ( this.delegate ) {
                    this.delegate.lineDidHide( currentLine, true );
                }
            
                this.slotPresenter.showActiveBillets( nextLine );
                this.slotPresenter.showCroppedLine( nextLine, this.math.lineWinPositions( nextLine ) );
            
                if ( this.delegate ) {
                    this.delegate.lineDidShow( nextLine, this.math.lineWin( nextLine ), true );
                }
            
                this.then( showNextLine_beforeExtra, 1000 );
            }
        }
    }
    showScattersWin_beforeExtra() {
        if ( this.delegate) {
            this.delegate.scattersDidShow( this.math.scatterWin(), true );
        }

        this.then( function () {

            if ( this.delegate) {
                this.delegate.scattersDidHide( true );
            }
            
            this.finishShowWin_beforeExtra();
        }, 1500);
    }
    finishShowWin_beforeExtra() {
        if ( this.delegate) {
            this.delegate.scattersDidHide();
        }
        this.interruptShowWin( this.slotPresenter, this.math );
        this.done();
    }

    /**
    * Starts win show process before on freespin win.
    * @param {Object} slotPresenter this
    * @param {Object} math Mathematics as data source to show wins properly
    * @param {Function} done Callback to be called on show ending
    * @memberOf SlotWinPresenter
    * */
    showFreeGamesSpinWin( slotPresenter, math, done ) {
        this.slotPresenter = slotPresenter;
        this.math = math;
        this.done = done;
        
        this.winLines = math.winLines();
        this.lineIdx = 0;
        
        // начало показа выигрыша (все что было до этого это приватные функции частей показа выигрыша)
        if (this.delegate) {
            this.delegate.winShowDidStart();
        }
        
        slotPresenter.startSymbolsAnimation();
        
        // прячем плашки
        for (var i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            slotPresenter.showInactiveBillets(i);
            slotPresenter.hideActiveBillets(i);
        }
        
        this.showWinBegin_freegames();
    }
    showWinBegin_freegames() {
        //если есть выигрышные линии и возможно скаттеры
        if ( this.winLines.length > 0 ) {
            this.then( this.showAllWinLines_freegames, 300 ); // дадим время погаснуть плашкам перед показом всех выигрышных линий
        }
        // если только скаттеры выиграли
        else if ( this.math.scatterWin() > 0 ) {
            this.then( this.showScattersWin_freegames, 500 );
        }
    }
    showAllWinLines_freegames() {
        for ( var i = 0; i < this.winLines.length; ++i ) {
            this.slotPresenter.showActiveBillets( this.winLines[ i ] );
            this.slotPresenter.showLine( this.winLines[ i ] );
        }
        
        this.then( this.hideAllWinLines_freegames, 1000 );
    }
    showScattersWin_freegames() {
        if ( this.delegate ) {
            this.delegate.scattersDidShow( this.math.scatterWin() );
        }

        this.then( function () {
            if ( this.delegate) {
                this.delegate.scattersDidHide();
            }
            
            this.finishShowWin_freegames();
        }, 1500);
    }
    hideAllWinLines_freegames() {
        for (var i = 0; i < this.winLines.length; ++i) {
            this.slotPresenter.hideActiveBillets( this.winLines[ i ] );
            this.slotPresenter.hideLine( this.winLines[ i ] );
        }
        
        this.then( this.showLinesOneByOne_freegames, 1000 );
    }
    showLinesOneByOne_freegames() {
        this.slotPresenter.showActiveBillets( this.currentLineId() );
        this.slotPresenter.showCroppedLine( this.currentLineId(), this.math.lineWinPositions( this.currentLineId() ) );
        
        if ( this.delegate ) {
            this.delegate.lineDidShow( this.currentLineId(), this.math.lineWin( this.currentLineId() ), true );
        }
        
        if ( this.winLines.length === 1 && this.math.scatterWin() === 0 ) {
            this.then( this.finishShowWin_freegames, 1000 );
        }
        else {
            this.then( this.showNextLine_freegames, 1000 );
        }
    }
    showNextLine_freegames() {
        var currentLine = this.currentLineId();
        
        // если показали последнюю линию
        if ( this.lineIdx == this.winLines.length - 1 ) {
            this.slotPresenter.hideActiveBillets( currentLine );
            this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );
            
            if ( this.delegate) {
                this.delegate.lineDidHide( currentLine, true );
            }

            if ( this.math.scatterWin() > 0) {
                this.showScattersWin_freegames();
            }
            else {
                this.then( this.finishShowWin_freegames, 1000 );
            }
        }
        else {
            var nextLine = this.nextLineId();
            
            if (currentLine != nextLine) {
                this.slotPresenter.hideActiveBillets( currentLine );
                this.slotPresenter.hideCroppedLine( currentLine, this.math.lineWinPositions( currentLine ) );
                
                if ( this.delegate ) {
                    this.delegate.lineDidHide( currentLine, true );
                }
                
                this.slotPresenter.showActiveBillets( nextLine );
                this.slotPresenter.showCroppedLine( nextLine, this.math.lineWinPositions( nextLine ) );
                
                if ( this.delegate ) {
                    this.delegate.lineDidShow( nextLine, this.math.lineWin( nextLine ), true );
                }
                
                this.then( this.showNextLine_freegames, 1000 );
            }
        }
    }
    finishShowWin_freegames() {
        if ( this.delegate ) {
            this.delegate.scattersDidHide();
        }
        this.interruptShowWin( this.slotPresenter, this.math );
        this.done();
    }

    terminate() {
        if (this.timeID) {
            clearTimeout(this.timeID);
            delete this.timeID
        }

        if ( this._symbolAnimation )
        {
            for ( const a of this._symbolAnimation ) a.stop()
        }
        delete this._symbolAnimation
        
        this.destroy( { children : true } )
        
        delete this.delegate
        delete this.showWinInterrupted
        delete this.hideBarrelElement
        delete this.showBarrelElement
        delete this._slotMath
        delete this._config
        delete this.barrelUpperContainer
        delete this._lines
        delete this._scatterFrames
        
        delete this._leftBillets
        delete this._rightBillets
        delete this._billets
    }

    static symbol_index_to_pos( config, i ) {
        return {
            col : i / config.barrel.rows | 0,
            row : i % config.barrel.rows | 0,
        }
    }

    static pos_to_symbol_index( config, pos ) {
        return pos.col * config.barrel.rows + pos.row
    }

    static is_valid_pos( config, pos ) {
        return pos.col >= 0 && pos.col < config.barrel.reels && pos.row >= 0 && pos.row < config.barrel.rows
    }
}



// WEBPACK FOOTER //
// ./src/library/slot_win_presenter.es6